module.exports = __webpack_public_path__ + "img/solar_phone-outline.03d9c77d.svg";